import React from 'react';
import styles from './Spinner.module.scss';

export function Spinner({ style }) {
  return <div role="status" style={style} className={styles.Spinner} />;
}
